import React from "react";
import { Link } from "react-router-dom";
import { PlayerMatch } from "../../models/PlayerMatch";
import { Team } from "../../models/Team";
import useLocalStorage from 'use-local-storage';
import styles from './Scoreboard.module.css'; // Import the CSS module

interface ScoreboardProps {
    team: Team;
    players: PlayerMatch[];
    teamScore: number | undefined;
}

const Scoreboard: React.FC<ScoreboardProps> = ({ team, players, teamScore }) => {
    const [isDark] = useLocalStorage<boolean>("isDark", false);
    players.sort((a, b) => b.rating2 - a.rating2);

    return (
        <div className={styles.scoreboardContainer}>
            <div className={styles.teamHeaderWrapper}>
                <Link 
                    to={`/team/${team.teamId}`} 
                    className={styles.teamHeader}
                    style={{ 
                        color: 'inherit',
                        textDecoration: 'none'
                    }}
                >
                    <img 
                        src={team.teamLogo} 
                        alt="TeamLogo" 
                        className={styles.teamLogo}
                        style={{ display: 'block' }}
                    />
                    <h4 className={styles.teamName} style={{ margin: 0, padding: 0, position: 'relative', top: '-2px' }}>
                        {team.teamName}
                        {teamScore !== undefined ? ` (${teamScore})` : null}
                    </h4>
                </Link>
            </div>
            
            <table
                className={`table table-striped ${isDark ? 'table-dark' : ''} ${styles.scoreboardTable} ${isDark ? styles.darkTable : ''}`}
            >
                <thead>
                    <tr>
                        <th>Navn</th>
                        <th>K/D/A</th>
                        <th>+/-</th>
                        <th>ADR</th>
                        <th>KAST%</th>
                        <th>Rating 2.0</th>
                    </tr>
                </thead>
                <tbody>
                    {players.map((player, index) => (
                        <tr key={index}>
                            <td>
                                <Link 
                                    to={`/player/${player.steamId}`} 
                                    style={{ 
                                        color: isDark ? '#f8f9fa' : '#212529',
                                        textDecoration: 'none'
                                    }}
                                >
                                    {player.account?.playerName || player.steamId}
                                </Link>
                            </td>
                            <td>{player.kills}/{player.deaths}/{player.assists}</td>
                            <td>{player.kills - player.deaths}</td>
                            <td>{player.adr}</td>
                            <td>{player.kast}%</td>
                            <td>{player.rating2}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Scoreboard;